import { /*LOCALE_ID, */APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { BlocksModule } from './modules/blocks/blocks.module';
import { FooterModule } from './modules/footer/footer.module';
import { HeaderModule } from './modules/header/header.module';
import { MobileModule } from './modules/mobile/mobile.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { RootComponent } from './components/root/root.component';
import { PageHomeOneComponent } from './pages/page-home-one/page-home-one.component';
import { ShopService } from './shared/services';
import localeIt from '@angular/common/locales//en-PK';
import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Product } from './shared/interfaces';
import { data } from './data';
import { WebsiteComponent } from './components/website/website.component';
registerLocaleData(localeIt, 'en-PK');

export function loadConfig(http: HttpClient) {
  console.time('api')
    return () => {
        return new Promise<any>((resolve, reject) => {
            http.get<{
                status: string,
                data: any
              }>(environment.apiurl + 'shop/')
                .subscribe(res => {
                  console.timeEnd('api');
                  var products = (res['data']['products']).map(e => {
                    var o: Product = {
                      availability: e.av,
                      badge: e.bg,
                      brand: e.br,
                      categories: e.c,
                      name: e.n,
                      pricesale: e.ps,
                      priceoriginal: e.po,
                      pricesaleuk: e.psuk,
                      priceoriginaluk: e.pouk,
                      slug: e.s,
                      descriptionshort: e.ds,
                      thumbnail: environment.baseurl + e.th,
                    };
                    return o;
                  });
                  data.products = products;
                  data.categories = res['data']['categories'];
                  data.homeslider = res['data']['homeslider'];
                  data.brands = res['data']['brands'];
                  resolve(null);
                })            
        });
    }
}

@NgModule({
    declarations: [
        // components
        AppComponent,
        RootComponent,
        // pages
        PageHomeOneComponent,
        WebsiteComponent,
    ],
    imports: [
        // modules (angular)
        BrowserModule.withServerTransition({ appId: 'serverApp' }),
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        // modules (third-party)
        CarouselModule,
        ToastrModule.forRoot(),
        // modules
        AppRoutingModule,
        BlocksModule,
        FooterModule,
        HeaderModule,
        MobileModule,
        SharedModule,
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'en-PK' },
        ShopService,
        { provide: APP_INITIALIZER, useFactory: loadConfig, deps: [HttpClient], multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
